'use strict';

const STATUS_ONLINE = 'status-online';
const STATUS_OFFLINE = 'status-offline';
const STATUS_CHECKING = 'status-checking';

export {
    STATUS_ONLINE,
    STATUS_OFFLINE,
    STATUS_CHECKING,
}
